import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {GeneralFilter, getServiceSuppliersResolved, Location, Partner, Project, Service, ServiceType} from '@app/shared';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {CreateServiceDrawerComponent} from '../../drawers/create-service-drawer/create-service-drawer.component';
import {ScreenService} from '@app/core';
import {combineLatest, Subject, take, takeUntil} from 'rxjs';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {AuthService} from '../../../../core/services/auth.service';
import {ProjectUtilsService} from '../../services/project-utils.service';

@Component({
  selector: 'app-project-tabset',
  standalone: false,

  templateUrl: './project-tabset.component.html',
  styleUrl: './project-tabset.component.less'
})
export class ProjectTabsetComponent implements AfterViewInit, OnInit, OnDestroy {

  @Input() project!: Project;
  @Input() withPadding: boolean = true;
  @Input() activeTabIndex: number = 0;
  @Output() navigateEvent = new EventEmitter<void>();
  @Output() isDocDrawerOpen: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  // Obtener los templates de cada tab
  @ViewChild('inboxTmpl', {static: true}) inboxTmpl!: TemplateRef<any>;
  @ViewChild('serviceTmpl', {static: true}) serviceTmpl!: TemplateRef<any>;
  @ViewChild('docTmpl', {static: true}) docTmpl!: TemplateRef<any>;
  @ViewChild('teamTmpl', {static: true}) teamTmpl!: TemplateRef<any>;
  @ViewChild('containersTmpl', {static: true}) containersTmpl!: TemplateRef<any>;

  afterViewInit: boolean = false;

  tabs: { name: string; icon: string; tmpl: TemplateRef<any> }[] = [];

  selectedService: Service | undefined;

  createServiceDrawer: any;
  serviceTypeFiltervalue: number = 0;
  servicesFilters: GeneralFilter[] = [
    {
      name: 'Tipo de servicio',
      icon: 'arrow_drop_down',
      active: false,
    },
  ];

  providerFilterValue: number = 0;
  providersFilters: GeneralFilter[] = [
    {
      name: 'Proveedor',
      icon: 'arrow_drop_down', // o el ícono que prefieras
      active: false,
    },
  ];


  selectedServicesIds = new Set<number>();

  showServiceFilters: boolean = true;

  isMobile$;

  showServices: Service[] = [];
  allServiceTypes: ServiceType[] = [];
  servOnlyOnProject: ServiceType[] = [];
  allProviderList: Partner[] = []
  providersOnlyOnProject: Partner[] = [];
  locations: Location[] = [];

  destroy$ = new Subject<void>();

  constructor(private cdRef: ChangeDetectorRef, private drawerService: NzDrawerService,
              public authService: AuthService, public ps: ProjectUtilsService,
              private screenService: ScreenService, public gs: GlobalValuesService) {
    this.isMobile$ = screenService.isMobile$;
  }

  // Saber si todos estan seleccionados
  get isAllSelected(): boolean {
    return this.project.services!.every(item => this.selectedServicesIds.has(item.id));
  }

  // Saber si solo algunos estan seleccionados
  get isIndeterminate(): boolean {
    const hasSelected = this.project.services!.some(item =>
      this.selectedServicesIds.has(item.id)
    );
    return !this.isAllSelected && hasSelected;
  }

  ngOnInit() {
    this.filterServices();

    this.gs.serviceTypes$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (serviceTypes) => {
        this.allServiceTypes = serviceTypes || [];
        this.servOnlyOnProject = this.getUniqueServiceTypesForProject()
      },
      error: (err) => {
        console.error('Error al cargar serviceTypes', err);
        this.allServiceTypes = [];
      },
    });

    this.gs.isPartnerReady$.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value) {
          this.allProviderList = this.gs.providerList;
          this.providersOnlyOnProject = this.getUniqueProvidersForProject();
        }
      });

    this.gs.places$.pipe(takeUntil(this.destroy$))
      .subscribe(value => this.locations = value);
  }

  onFilterSelect(id: number) {
    if (this.serviceTypeFiltervalue === id) {
      this.serviceTypeFiltervalue = 0;
    } else {
      this.serviceTypeFiltervalue = id;
    }
    this.servicesFilters[0].active = !!this.serviceTypeFiltervalue;
    this.filterServices();
  }

  onProviderFilterSelect(id: number) {
    if (this.providerFilterValue === id) {
      this.providerFilterValue = 0; // Deseleccionar si es el mismo
    } else {
      this.providerFilterValue = id;
    }

    this.providersFilters[0].active = !!this.providerFilterValue;
    this.filterServices();
  }

  filterServices() {
    let tempFilter = this.project.services;

    if (tempFilter && tempFilter.length > 0 && this.serviceTypeFiltervalue) {
      tempFilter = tempFilter!.filter(s => s.typeId === this.serviceTypeFiltervalue)
    }
    if (tempFilter && tempFilter.length > 0 && this.providerFilterValue) {
      tempFilter = tempFilter.filter(s => {
        const { supplierIds } = getServiceSuppliersResolved(s);
        return supplierIds.includes(this.providerFilterValue) || s.supplierId === this.providerFilterValue;
      });
    }

    this.showServices = tempFilter || [];

    if (!this.authService.loggedUser$.value?.viewUnassignedProjectsAndServices) {
      const userPartnerId = this.authService.loggedUser$.value?.partner.id;
      if (userPartnerId) {
        this.showServices = this.showServices.filter(s => {
          const { supplierIds } = getServiceSuppliersResolved(s);
          return supplierIds.includes(userPartnerId) || s.supplierId === userPartnerId;
        });
      } else {
        this.showServices = [];
      }
    }
  }

  ngAfterViewInit(): void {
    this.tabs = [
      // {name: 'Inbox', icon: 'inbox', tmpl: this.inboxTmpl},
      {name: 'Servicios', icon: 'checklist', tmpl: this.serviceTmpl},
      {name: 'Documentos', icon: 'description', tmpl: this.docTmpl},
      {name: 'Contenedores', icon: 'calendar_view_week', tmpl: this.containersTmpl},
      // {name: 'Equipos', icon: 'warehouse', tmpl: this.teamTmpl},
    ];

    this.afterViewInit = true;
    this.cdRef.detectChanges();
  }

  emitNavigateEvent(): void {
    this.navigateEvent.emit();
  }

  openCreateServiceDrawer(): void {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.createServiceDrawer = this.drawerService.create({
        nzWidth: 793,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzClosable: false,
        nzMaskClosable: false,
        nzContent: CreateServiceDrawerComponent,
        nzData: {
          project: this.project,
        }
      });

      this.createServiceDrawer.afterClose.pipe(take(1)).subscribe(() => {
        this.filterServices();
        this.cdRef.detectChanges()
      })
    });

  }

  // Alternamiento individual
  toggleSelectService(id: number): void {
    if (this.selectedServicesIds.has(id)) {
      this.selectedServicesIds.delete(id);
    } else {
      this.selectedServicesIds.add(id);
    }
  }

  // Alternamiento total
  toggleSelectAllServices(): void {
    const newSet = new Set(this.selectedServicesIds);

    if (this.isAllSelected) {
      this.project.services?.forEach(item => newSet.delete(item.id));
    } else {
      this.project.services?.forEach(item => newSet.add(item.id));
    }

    this.selectedServicesIds = newSet;
  }

  sendIsDocDrawerOpen(value: boolean) {
    this.isDocDrawerOpen.emit(value);
  }

  toggleShowFilters() {
    this.showServiceFilters = !this.showServiceFilters;
  }

  getUniqueServiceTypesForProject(): ServiceType[] {
    //Verificar si el proyecto tiene servicios
    if (!this.project?.services?.length) {
      return [];
    }
    //  Obtener ids únicos
    const uniqueTypeIds = new Set<number>(
      this.project.services
        .map(service => service.typeId)
        .filter((typeId): typeId is number => typeof typeId === 'number')
    );
    //Filtrar la lista completa de tipos
    return this.allServiceTypes.filter(serviceType =>
      uniqueTypeIds.has(serviceType.id)
    );
  }

  getUniqueProvidersForProject(): any[] {
    if (!this.project?.services?.length) {
      return [];
    }

    // Obtener IDs de proveedores únicos usados en los servicios del proyecto
    // Incluir tanto supplierIds (array) como supplierId (único) para compatibilidad
    const uniqueProviderIds = new Set<number>();
    
    this.project.services.forEach(service => {
      const { supplierIds } = getServiceSuppliersResolved(service);
      supplierIds.forEach(id => uniqueProviderIds.add(id));
      if (service.supplierId) uniqueProviderIds.add(service.supplierId);
    });

    return this.gs.providerList.filter(provider =>
      uniqueProviderIds.has(provider.id)
    );
  }

  closeAllDrawers() {
    this.ps.closeAllDrawers$.next(true);
    setTimeout(() => {
      this.ps.closeAllDrawers$.next(false);
    }, 100)
  }
  refreshData() {
    // Volver a aplicar filtros
    this.filterServices();

    // Recargar tipos de servicio y proveedores si es necesario
    this.servOnlyOnProject = this.getUniqueServiceTypesForProject();
    this.providersOnlyOnProject = this.getUniqueProvidersForProject();

    // Forzar detección de cambios
    this.cdRef.detectChanges();

  }

  getLocation(id: number | undefined): Location | undefined {
    return this.locations.find(l => l.id === id);
  }

  /** Resuelve suppliers/supplierIds de un service con fallback a serviceSuppliers (para template) */
  getResolvedSuppliers(service: Service) {
    return getServiceSuppliersResolved(service);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
